import { collection, getDocs } from 'firebase/firestore';
import { db } from '../lib/firebase';

interface Category {
  id: string;
  name: string;
  parentId: string | null;
  level: number;
}

let categoriesCache: Record<string, Category> | null = null;

export const loadCategories = async () => {
  if (categoriesCache) return categoriesCache;

  try {
    const snapshot = await getDocs(collection(db, 'categories'));
    const categories = snapshot.docs.reduce((acc, doc) => {
      acc[doc.id] = { id: doc.id, ...doc.data() } as Category;
      return acc;
    }, {} as Record<string, Category>);

    categoriesCache = categories;
    return categories;
  } catch (err) {
    console.error('Erro ao carregar categorias:', err);
    return {};
  }
};

export const getCategoryFullName = async (categoryId: string): Promise<string> => {
  if (!categoryId) return 'Sem categoria';

  const categories = await loadCategories();
  const category = categories[categoryId];
  if (!category) return 'Categoria não encontrada';

  const parts: string[] = [category.name];
  let currentCategory = category;

  while (currentCategory.parentId) {
    const parentCategory = categories[currentCategory.parentId];
    if (!parentCategory) break;
    parts.unshift(parentCategory.name);
    currentCategory = parentCategory;
  }

  return parts.join(' > ');
};

// Limpar o cache quando necessário (por exemplo, após atualizações)
export const clearCategoriesCache = () => {
  categoriesCache = null;
};
